import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { BuildingType } from 'src/app/shared/location-details-wizard/location-details-wizard.state';

import { ActionSource } from '../../state/action-sources';

export const LocationDetailsWizardActions = createActionGroup({
  source: ActionSource.LOCATION_DETAILS_WIZARD,
  events: {
    'Option Clicked': props<{
      value: BuildingType | string;
    }>(),
    'Back Button Clicked': emptyProps(),
    'Overlay Hidden': emptyProps(),
  },
});
